import { queryClient } from '@/providers/query-client'
import { tenant } from '@/tenants/tenant'
import type { LoginConfig } from '@/tenants/tenant-config'
import { StoredBooleanSubject } from './storage'

export const TESTER_PHONE = '6000000'
export const TESTER_API_URL = 'https://api.demo.fast-track.io'
export const TESTER_PUBLISHABLE_KEY = 'pk_aa0e1c0e5ed986e2bebc11b1ba665451c843239d4f1aa4efbc5d930e1fb04848'

export const testerModeEnabled = new StoredBooleanSubject('isTesterMode', false)

export const isTesterMode = () => {
	return testerModeEnabled.value
}
export const getBackendUrl = () => {
	if (testerModeEnabled.value) {
		return TESTER_API_URL
	}
	if (__BACKEND_URL__) {
		return __BACKEND_URL__
	}
	return tenant.apiUrl
}

export const getPublishableKey = () => {
	if (testerModeEnabled.value) {
		return TESTER_PUBLISHABLE_KEY
	}
	return tenant.publishableKey
}

/**
 * Resolves the active login configuration. Tester mode is always anonymous.
 * Returns `null` when the tenant uses the carousel onboarding (no account login).
 */
export const getLoginConfig = (): LoginConfig | null => {
	if (testerModeEnabled.value) {
		return { method: 'anonymous' }
	}
	const { onboarding } = tenant.features
	return onboarding.style === 'fullscreen' ? onboarding.login : null
}

/** Whether the tenant uses an account-based login (Taktikal/email), not anonymous. */
export const hasAccountLogin = () => {
	const login = getLoginConfig()
	return login !== null && login.method !== 'anonymous'
}

export const isLoginRequired = () => {
	const login = getLoginConfig()
	return login !== null && login.method !== 'anonymous' && login.required
}

export const turnOnTesterMode = () => {
	testerModeEnabled.next(true)
	queryClient.clear()
}
